import add from 'Ractive/prototype/add';
import animate from 'Ractive/prototype/animate';
import detach from 'Ractive/prototype/detach';
import find from 'Ractive/prototype/find';
import findAll from 'Ractive/prototype/findAll';
import findAllComponents from 'Ractive/prototype/findAllComponents';
import findComponent from 'Ractive/prototype/findComponent';
import findContainer from 'Ractive/prototype/findContainer';
import findParent from 'Ractive/prototype/findParent';
import fire from 'Ractive/prototype/fire';
import get from 'Ractive/prototype/get';
import insert from 'Ractive/prototype/insert';
import merge from 'Ractive/prototype/merge';
import observe from 'Ractive/prototype/observe';
import observeOnce from 'Ractive/prototype/observeOnce';
import off from 'Ractive/prototype/off';
import on from 'Ractive/prototype/on';
import once from 'Ractive/prototype/once';
import pop from 'Ractive/prototype/pop';
import push from 'Ractive/prototype/push';
import render from 'Ractive/prototype/render';
import reset from 'Ractive/prototype/reset';
import resetPartial from 'Ractive/prototype/resetPartial';
import resetTemplate from 'Ractive/prototype/resetTemplate';
import reverse from 'Ractive/prototype/reverse';
import set from 'Ractive/prototype/set';
import shift from 'Ractive/prototype/shift';
import sort from 'Ractive/prototype/sort';
import splice from 'Ractive/prototype/splice';
import subtract from 'Ractive/prototype/subtract';
import teardown from 'Ractive/prototype/teardown';
import toggle from 'Ractive/prototype/toggle';
import toHTML from 'Ractive/prototype/toHTML';
import unrender from 'Ractive/prototype/unrender';
import unshift from 'Ractive/prototype/unshift';
import update from 'Ractive/prototype/update';
import updateModel from 'Ractive/prototype/updateModel';

export default {
	add: add,
	animate: animate,
	detach: detach,
	find: find,
	findAll: findAll,
	findAllComponents: findAllComponents,
	findComponent: findComponent,
	findContainer: findContainer,
	findParent: findParent,
	fire: fire,
	get: get,
	insert: insert,
	merge: merge,
	observe: observe,
	observeOnce: observeOnce,
	off: off,
	on: on,
	once: once,
	pop: pop,
	push: push,
	render: render,
	reset: reset,
	resetPartial: resetPartial,
	resetTemplate: resetTemplate,
	reverse: reverse,
	set: set,
	shift: shift,
	sort: sort,
	splice: splice,
	subtract: subtract,
	teardown: teardown,
	toggle: toggle,
	toHTML: toHTML,
	toHtml: toHTML,
	unrender: unrender,
	unshift: unshift,
	update: update,
	updateModel: updateModel
};
